module.exports = __webpack_public_path__ + "img/caselist30.238946bf.jpg";